import styled from 'styled-components';

export const LogoImage = styled.img`
  flex: none;
  height: 28px;
  max-width: 150px;
  margin-right: 8px;
  object-fit: contain;
`;
